import { render, staticRenderFns } from "./tord_check_unpass.vue?vue&type=template&id=e15a619a&scoped=true&"
import script from "./tord_check_unpass.vue?vue&type=script&lang=js&"
export * from "./tord_check_unpass.vue?vue&type=script&lang=js&"
import style0 from "./tord_check_unpass.vue?vue&type=style&index=0&id=e15a619a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15a619a",
  null
  
)

export default component.exports